import * as React from "react";
import * as moment from "moment";
import * as _ from "lodash";
import { IContact, IProduct } from "@nkr/models/index";
import { Button, FormControl, Panel } from "react-bootstrap";
import * as DateTimeModule from "react-datetime";

const DateTime = (DateTimeModule as any).default;

interface IProps {
    productList: IProduct[],
    staffList: IContact[],
    nkrLiaisonId: number,
    nkrExecutiveSponsorId: number,
    onAddProduct: (productId: number, nextSteps: string, targetDate: string) => void,
}

interface IState {
    productId: number,
    productValid: boolean,
    nextSteps: string,
    targetDate: string,
    isDirty: boolean
}

class AddProduct extends React.Component<IProps, IState> {
    readonly state: IState = {
        productId: 0,
        productValid: true,
        nextSteps: '',
        targetDate: moment().format("MM/DD/YYYY"),
        isDirty: false
    }

    componentWillReceiveProps = (nextProps: IProps) => { }

    handleProductChange = (e: React.FormEvent<HTMLSelectElement & FormControl>) => {
        let productId = parseInt(e.currentTarget.value);
        let productValid = this.state.isDirty ? productId > 0 : true;

        this.setState({
            productId,
            productValid
        });
    }

    handleNextStepsChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            nextSteps: e.currentTarget.value
        });
    }

    handleTargetDateChange = (e: moment.Moment) => {
        this.setState({
            targetDate: e.format('MM/DD/YYYY')
        });
    }

    handleAddProduct = () => {
        let { productId, targetDate, nextSteps } = this.state;
        let productValid = this.state.productId > 0;

        if (productValid) {
            this.setState({
                productId: 0,
                targetDate: '',
                nextSteps: ''
            }, () => {
                if (productValid) {
                    this.props.onAddProduct(productId, nextSteps, targetDate);
                }
            });
        } else {
            this.setState({
                productValid,
                isDirty: true
            });
        }
    }

    render = () => {
        return (
            <>
                <Panel>
                    <Panel.Heading>
                        <Panel.Title>Target a New Product</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <div className='row' style={{ marginBottom: 10 }}>
                            <div className='col-xs-12 col-lg-1'>Product:</div>
                            <div className='col-xs-12 col-lg-6'>
                                <FormControl
                                    componentClass="select"
                                    value={this.state.productId}
                                    onChange={this.handleProductChange}
                                >
                                    <option value={0}>- select product -</option>
                                    {this.props.productList.map((p, index) =>
                                        <option key={'ptp-' + index} value={p.id}>{p.name} ({p.owner})</option>
                                    )}
                                </FormControl>
                            </div>
                        </div>

                        <div className='row' style={{ marginBottom: 10 }}>
                            <div className='col-xs-12 col-lg-1'>Next Steps:</div>
                            <div className='col-xs-12 col-lg-6'>
                                <FormControl
                                    componentClass='textarea'
                                    style={{ height: 75 }}
                                    value={this.state.nextSteps}
                                    onChange={this.handleNextStepsChange}
                                />
                            </div>
                        </div>

                        <div className='row' style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='col-xs-12 col-lg-1'>Target Date:</div>
                            <div className='col-xs-12 col-lg-6'>
                                <DateTime
                                    value={this.state.targetDate}
                                    input={true}
                                    dateFormat={"MM/DD/YYYY"}
                                    timeFormat={false}
                                    closeOnSelect={true}
                                    inputProps={{ className: "form-control", style: { width: 'initial' } }}
                                    onChange={this.handleTargetDateChange}
                                />
                            </div>
                        </div>
                    </Panel.Body>
                    <Panel.Footer>
                        <Button bsStyle="primary" onClick={this.handleAddProduct}>Add Product</Button>
                    </Panel.Footer>
                </Panel>
            </>
        );
    }
}

export default AddProduct;